export const fallback = {
  in: { m: '0.0254', dm: '0.254', cm: '2.54', mm: '25.4', ft: '0.083333333333333333333333333' },
  m: { in: '39.37007874015748191535032070', ft: '3.280839895013123194187330567', dm: '10', cm: '100', mm: '1000' },
  dm: { in: '3.937007874015747976428890836', ft: '0.3280839895013123313690742364', m: '0.1', cm: '10', mm: '100' },
  cm: { in: '0.3937007874015747976428890836', ft: '0.03280839895013123313690742364', m: '0.01', dm: '0.1', mm: '10' },
  mm: {
    in: '0.03937007874015748251764751615',
    ft: '0.003280839895013123237208558814',
    m: '0.001',
    dm: '0.01',
    cm: '0.1',
  },
  ft: { in: '12.00000000000000000000000005', m: '0.3048', dm: '3.048', cm: '30.48', mm: '304.8' },
  lb: { kg: '0.453592' },
  kg: { lb: '2.204624420183777515012178124' },
  cfm: { 'm^3/s': '0.000471947', 'm^3/h': '1.69901', 'ft^3/m': '1', 'ft^3/s': '0.01666666666667' },
  'm^3/s': {
    cfm: '2118.881993105157935175546973',
    'ft^3/m': '2118.881993105157935175546973',
    'ft^3/s': '35.31472482766414284099898294',
    'm^3/h': '3600',
  },
  'm^3/h': {
    cfm: '0.5885780542786681970366391148',
    'ft^3/m': '0.5885780542786681970366391148',
    'ft^3/s': '0.009809595746559284291894331035',
    'm^3/s': '0.0002777777777777777777777777778',
  },
  'ft^3/m': { cfm: '1', 'ft^3/s': '0.01666666666667', 'm^3/s': '0.000471947', 'm^3/h': '1.69901' },
  'ft^3/s': {
    cfm: '59.99999999998800000000000240',
    'ft^3/m': '59.99999999998800000000000240',
    'm^3/s': '0.0283168',
    'm^3/h': '101.941',
  },
  Btu: {
    J: '1055.05585',
    kJ: '1.05505585',
    MJ: '0.00105505585',
    Wh: '0.293071070172',
    kWh: '0.000293071070172',
    MWh: '0.000000293071070172',
  },
  J: {
    Btu: '0.0009478171226670133149823300823',
    kJ: '0.001',
    MJ: '1e-06',
    Wh: '0.000277778',
    kWh: '0.000000277778',
    MWh: '0.000000000277778',
  },
  kJ: {
    Btu: '0.9478171226670133149823300823',
    J: '1000',
    MJ: '0.001',
    Wh: '0.277778',
    kWh: '0.000277778',
    MWh: '0.000000277778',
  },
  MJ: { Btu: '947.81707774915', J: '1000000', kJ: '1000', Wh: '277.778', kWh: '0.277778', MWh: '0.000277778' },
  Wh: { Btu: '3.412141633130529189051478126', J: '3600', kJ: '3.6', MJ: '0.0036', kWh: '0.001', MWh: '0.000001' },
  kWh: { Btu: '3412.141633130529189051478126', J: '3600000', kJ: '3600', MJ: '3.6', Wh: '1000', MWh: '0.001' },
  MWh: { Btu: '3412142.450123', J: '3600000000', kJ: '3600000', MJ: '3600', Wh: '1000000', kWh: '1000' },
  'Btu/h': { W: '0.293071', mW: '293.071', kW: '0.000293071', MW: '2.93071e-07', mbh: '0.001' },
  W: { 'Btu/h': '3.412142450123007433416669415', mW: '1000', kW: '0.001', MW: '1e-06', mbh: '0.003412142450123007433416669415' },
  mW: { 'Btu/h': '0.00341214', W: '0.001', kW: '1e-06', MW: '1e-09', mbh: '0.00000341214' },
  kW: { 'Btu/h': '3412.142450123007736370063556', W: '1000', mW: '1000000', MW: '0.001', mbh: '3.412142450123007736370063556' },
  MW: { 'Btu/h': '3412142', W: '1000000', mW: '1000000000', kW: '1000', mbh: '3412.142' },
  mbh: { 'Btu/h': '1000', W: '293.071', mW: '293071', kW: '0.293071', MW: '0.000293071', }
};

export const fallbackByType = {
  length: ['m', 'dm', 'cm', 'mm', 'ft', 'in'],
  mass: ['kg', 'lb'],
  volumetricFlowRate: ['m^3/s', 'm^3/h', 'cfm', 'ft^3/m', 'ft^3/s'],
  power: ['W', 'kW', 'MW', 'mW', 'Btu/h', "mbh"],
  energy: ['J', 'kJ', 'MJ', 'Wh', 'kWh', 'MWh', 'Btu'],
};
